const labelElement = document.querySelector('label[for="pa_size"]');

if (labelElement) {
    // Create a new div element
    const divElement = document.createElement('span');

    // Add a class to the new div element
    divElement.className = 'size-chart'; // Replace 'your-class-name' with the desired class name

    // Add text "Size Chart" inside the div
    divElement.textContent = 'Size Chart';

    // Insert the new div element as a sibling after the label
    labelElement.parentNode.insertBefore(divElement, labelElement.nextSibling);

    // Add click event listener to the div
    divElement.addEventListener('click', function() {
        // Get the size chart button element with the specified class
        const sizeChartButton = document.querySelector('.md-size-chart-btn');

        // Check if the button exists and trigger a click on it
        if (sizeChartButton) {
            sizeChartButton.click();
        }
    });
}